import type { ExcelGridRow, ExcelGridSelectOption } from "../models/excel-grid.models";
import type { StylesConfig } from "react-select";

export const GRID_SCROLLER_CLASS_NAME =
  "border-greyscale-20 min-h-0 min-w-0 max-w-full flex-1 overflow-auto border bg-white outline-none focus:border-green dark:border-gray-700 dark:bg-gray-800";
export const GRID_SCROLLBAR_CLASS_NAME =
  "[scrollbar-color:#B7C9C4_#F3F4F4] [&::-webkit-scrollbar]:h-2.5 [&::-webkit-scrollbar]:w-2.5 [&::-webkit-scrollbar-thumb]:bg-[#B7C9C4] [&::-webkit-scrollbar-track]:bg-[#F3F4F4] [&::-webkit-scrollbar-thumb]:rounded-full hover:[&::-webkit-scrollbar-thumb]:bg-[#899996]";
export const GRID_TABLE_CLASS_NAME = "excel-grid-table min-w-full border-separate border-spacing-0 text-left";
export const GRID_REGION_LABEL = "Spreadsheet data table";
export const DEFAULT_VIRTUALIZED_MAX_HEIGHT = 600;
export const EMPTY_COLUMN_WIDTH_ROWS: ExcelGridRow[] = [];

export const EXCEL_GRID_HEADER_CLASS_NAME =
  "sticky top-0 z-10 bg-[#F7FBFA] text-xs font-semibold uppercase text-[#4A5655] dark:bg-gray-900 dark:text-gray-300";

const EXCEL_GRID_SELECT_MENU_PORTAL_Z_INDEX = 10000;
export const EXCEL_GRID_SELECT_BLUR_CANCEL_DELAY_MS = 100;

export const EXCEL_GRID_SELECT_EDITOR_STYLES: StylesConfig<ExcelGridSelectOption, false> = {
  container: (base) => ({
    ...base,
    minHeight: "16px",
    width: "100%",
  }),
  control: (base) => ({
    ...base,
    minHeight: "16px",
    height: "16px",
    border: 0,
    borderRadius: 0,
    backgroundColor: "transparent",
    boxShadow: "none",
    cursor: "text",
  }),
  valueContainer: (base) => ({
    ...base,
    height: "16px",
    padding: 0,
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
    color: "inherit",
  }),
  singleValue: (base) => ({
    ...base,
    margin: 0,
    color: "inherit",
  }),
  placeholder: (base) => ({
    ...base,
    margin: 0,
    color: "#6B7473",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "16px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: 0,
    color: "#6B7473",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  menu: (base) => ({
    ...base,
    zIndex: EXCEL_GRID_SELECT_MENU_PORTAL_Z_INDEX,
    marginTop: 2,
    fontSize: "12px",
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: EXCEL_GRID_SELECT_MENU_PORTAL_Z_INDEX,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? "#1F8475" : state.isFocused ? "#E9F4F3" : base.backgroundColor,
    color: state.isSelected ? "#FFFFFF" : "#111827",
    cursor: "pointer",
    padding: "6px 8px",
  }),
};
